import { amplitude } from './amplitude';
import { routeMarketingEvent } from './marketingRouter';

function normalizeAmplitudeProps(event) {
  const props = { ...event };

  if ('quiz_answer' in props) {
    props.answer = props.quiz_answer;
    delete props.quiz_answer;
  }

  return props;
}

export function send({ event }) {
  if (!event || !event.event) {
    return;
  }

  let amplitudeEventName = event.event;
  const amplitudeProps = normalizeAmplitudeProps(event);

  if (event.event === 'quiz_funnel' && event.quiz_action) {
    amplitudeEventName = event.quiz_action;
    delete amplitudeProps.quiz_action;
    delete amplitudeProps.event;
  } else if (event.event === 'onboarding_question' && event.quiz_question) {
    amplitudeEventName = event.quiz_question;
    delete amplitudeProps.quiz_question;
    delete amplitudeProps.event;
  } else if (event.event === 'AB_TEST') {
    amplitudeEventName = 'AB_TEST';
    delete amplitudeProps.event;
  } else {
    delete amplitudeProps.event;
  }

  if (amplitude && typeof amplitude.track === 'function') {
    amplitude.track(amplitudeEventName, amplitudeProps);
  }

  routeMarketingEvent(event);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}
